
import { Options, Vue } from 'vue-class-component';
import VLazyImage from "v-lazy-image";

@Options({
  components: {
    VLazyImage,
  },
})
export default class dogImage extends Vue {
    // eslint-disable-next-line
    $store: any;

    get dogimages() {
        return this.$store.getters.dogimages
    }

    created() {
        this.$store.dispatch('fetchRandomDogs');
    }

    selectDog(dogimage: string) {
        this.$store.dispatch("setSelectedDog", dogimage);
        this.$router.push({ name: "dogDetails" });
    }
}
